
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.394 29.865l-6.123-6.123a2.926 2.926 0 00-4.138 0l-3.3 3.3c-.24.24-1.2.374-2.85-.244a15.555 15.555 0 01-5.257-3.524 15.546 15.546 0 01-3.523-5.257c-.617-1.651-.483-2.609-.244-2.85l3.3-3.3a2.924 2.924 0 000-4.138l-6.123-6.123a2.93 2.93 0 00-4.136 0L2.464 5.139c-4.2 4.2-.369 14.6 8.713 23.685a40.753 40.753 0 0013.31 9.2 15.908 15.908 0 005.668 1.226 6.384 6.384 0 004.707-1.713L38.394 34a2.93 2.93 0 000-4.135zM6.083 4.146l1.228-1.227a1.1 1.1 0 011.512 0l6.122 6.122a1.071 1.071 0 010 1.513l-1.226 1.227zm5.383 14.519a17.238 17.238 0 003.95 5.919 17.223 17.223 0 005.919 3.951c2.144.8 3.9.735 4.814-.182l.756-.756 7.636 7.634-.991.991c-1.524 1.527-4.582 1.552-8.388.069a38.872 38.872 0 01-12.671-8.78C4.423 19.442.432 9.8 3.777 6.451l.993-.991 7.637 7.64-.757.757c-.917.911-.984 2.665-.184 4.808zM37.082 32.69l-1.228 1.227-7.635-7.635 1.228-1.227a1.1 1.1 0 011.512 0l6.123 6.122a1.071 1.071 0 010 1.513z"}})])
          )
        }
      }
    